export default __webpack_public_path__ + "static/emphasise-metric-do-ae8328a1d34c6b5a3e76514bd786d87f.png";